var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1568 14.8613C13.8769 14.8613 12.8215 15.8942 12.8215 17.1966C12.8215 18.4765 13.8545 19.5319 15.1568 19.5319C16.4367 19.5319 17.4921 18.499 17.4921 17.1966C17.4697 15.9167 16.4367 14.8613 15.1568 14.8613Z",
    fill: "#5B6673"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2661 3.72395C19.2212 3.72395 19.1539 3.7015 19.0865 3.7015H4.94004L4.71549 2.19703C4.58076 1.20902 3.72748 0.468018 2.71702 0.468018H0.898188C0.404185 0.468018 0 0.872202 0 1.36621C0 1.86021 0.404185 2.26439 0.898188 2.26439H2.71702C2.82929 2.26439 2.91911 2.35421 2.94157 2.46649L4.33376 11.9424C4.5134 13.1325 5.54631 14.0307 6.75887 14.0307H16.1C17.2677 14.0307 18.2781 13.1998 18.5251 12.0546L19.9847 4.75687C20.0745 4.28532 19.7601 3.81377 19.2661 3.72395Z",
    fill: "#5B6673"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43112 17.0843C9.38621 15.8493 8.35329 14.8613 7.11828 14.8613C5.81591 14.9287 4.8279 16.0065 4.87281 17.2864C4.91772 18.5214 5.92818 19.5095 7.16319 19.5095H7.2081C8.48802 19.4421 9.49848 18.3643 9.43112 17.0843Z",
    fill: "#5B6673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.7ace05682616ba11cf37e7cb16752a83.svg";
export { ForwardRef as ReactComponent };